<template>
  <div v-if="loading">Loading...</div>
  <div v-else>
    <v-sheet tile height="54" class="d-flex">
      <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        class="ma-2 hidden-sm-and-down"
        label="type"
      ></v-select>
      <v-select
        v-model="mode"
        :items="modes"
        dense
        outlined
        hide-details
        label="event-overlap-mode"
        class="ma-2 hidden-sm-and-down"
      ></v-select>
      <v-select
        v-model="weekday"
        :items="weekdays"
        dense
        outlined
        hide-details
        label="weekdays"
        class="ma-2 hidden-sm-and-down"
      ></v-select>
      <v-spacer></v-spacer>
      <v-btn icon class="ma-2" @click="$refs.calendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :type="type"
        :events="appointments"
        @click:event="showDialog"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
        :event-color="(event) => event.color"
        @change="getEvents"
      />
    </v-sheet>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: 'month',
      types: ['month', 'week', 'day', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] }
      ],
      value: '',
      selectedElement: null,
      selectedOpen: false,
      selectedEvent: {},
      colors: {
        Pending: 'grey',
        Approved: 'green',
        Declined: 'red',
        Finished: 'blue'
      },
      confirm: false
    }
  },
  props: {
    loading: { type: Boolean, required: true },
    appointments: { type: Array, required: true },
    getColor: { type: Function, required: true },
    showDialog: { type: Function, required: true }
  },
  methods: {
    getEvents () {
      // TODO: Get new events with new arguments
    }
  }
}
</script>
